import { render, staticRenderFns } from "./LoginActivation.vue?vue&type=template&id=c468f8e2&scoped=true&"
import script from "./LoginActivation.vue?vue&type=script&lang=js&"
export * from "./LoginActivation.vue?vue&type=script&lang=js&"
import style0 from "./LoginActivation.vue?vue&type=style&index=0&id=c468f8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c468f8e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VApp,VBtn,VCol,VContainer,VContent,VRow})
